import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
  min-width: 0;

  @media (max-width: 1024px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
